import {Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FieldsService} from '../../../core/fields/fields.service';
import {BsModalRef} from 'ngx-bootstrap';
import {AccountsService} from '../../../core/accounts/accounts.service';

@Component({
  selector: 'app-new-account',
  templateUrl: './new-account.component.html',
  styleUrls: ['./new-account.component.scss']
})
export class NewAccountComponent implements OnInit {

  @ViewChild('search') addressSearchElementRef: ElementRef;

  place: any;

  accountForm: FormGroup;

  fields: any[];

  fieldValues: any[] = [];

  constructor(private fb: FormBuilder,
              private zone: NgZone,
              public modalRef: BsModalRef,
              private accountsService: AccountsService,
              private fieldsService: FieldsService) {}

  ngOnInit() {
    const name = this.place ? this.place.name : '';
    const address = this.place ? this.place.formatted_address : '';
    const placeId = this.place ? this.place.place_id : '';
    const coords = this.place && this.place.geometry ? [this.place.geometry.location.lng(), this.place.geometry.location.lat()] : [];
    const phone = this.place ? this.place.formatted_phone_number : '';
    const website = this.place ? this.place.website : '';
    const notes = this.place && this.place.opening_hours ? this.place.opening_hours.weekday_text.join('\n') : '';

    this.addressSearchElementRef.nativeElement.value = address;

    this.accountForm = this.fb.group({
      name: [name, Validators.required],
      address: [address, Validators.required],
      placeId: [placeId, Validators.required],
      coords: [coords, Validators.required],
      phone: [phone],
      email: [''],
      website: [website],
      referrals: [''],
      notes: [notes]
    });

    const autocomplete = new google.maps.places.Autocomplete(this.addressSearchElementRef.nativeElement, {
      types: ['address'],
      componentRestrictions: {country: ['us']}
    });

    autocomplete.addListener('place_changed', () => {
      this.zone.run(() => {
        const place = autocomplete.getPlace();

        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        this.accountForm.controls['address'].setValue(place.formatted_address);
        this.accountForm.controls['placeId'].setValue(place.place_id);
        this.accountForm.controls['coords'].setValue([place.geometry.location.lng(), place.geometry.location.lat()]);
      });
    });

    this.fieldsService.listFieldValues()
      .subscribe((fields: any[]) => {
        this.fields = fields;
      });

  }

  createAccount() {
    this.accountsService.create({account: this.accountForm.value, fieldValues: this.fieldValues})
      .subscribe(() => {
        this.modalRef.hide();
      }, err => {
        alert(err.error.message || 'An error occurred');
      });
  }

  onAdd(e) {
    this.fieldValues.push(e);
  }

}



// WEBPACK FOOTER //
// ./client/app/components/shared/new-account/new-account.component.ts